module.exports = __webpack_public_path__ + "img/8-poster.f79d95ea.jpg";